import { gql } from "utils/urql";
import { forwardRef } from "react";
import styles from "./ArticleRelatedContentLink.module.scss";
import { ArticleRelatedContentLinkFragment } from "types/api";

const ArticleRelatedContentLink = forwardRef<
  HTMLParagraphElement,
  ArticleRelatedContentLinkFragment & { count: number }
>(function ArticleRelatedContentLink({ idAttr, innerHtml, count }, ref) {
  return (
    <p
      ref={ref}
      id={idAttr || undefined}
      className={styles.root}
      dangerouslySetInnerHTML={{ __html: innerHtml }}
      data-view-action={`view link - injected link - item ${count}`}
      // data-view-label is set directly in GTM
    />
  );
});

ArticleRelatedContentLink.fragment = gql`
  fragment articleRelatedContentLink on ArticleRelatedContentLink {
    idAttr
    innerHtml
  }
`;

export default ArticleRelatedContentLink;
